const KEY = "bearcms_organization_id" as string;

/**
 * @description get organization id from localStorage
 */
export const currentOrganization = (): number => {
    if (typeof window === 'undefined') return 0;
    return parseInt(window.localStorage.getItem(KEY) ?? '0');
};

/**
 * @description save organization id into localStorage
 */
export const setOrganization = (id: number): void => {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(KEY, id.toString());
};

/**
 * @description remove organization id from localStorage
 */
export const clearOrganization = (): void => {
    if (typeof window === 'undefined') return;
    window.localStorage.removeItem(KEY);
};

export default { currentOrganization, setOrganization, clearOrganization };

const SYSTEM_OBJECT_KEY = "bearcms_system_object_id" as string;

/** Id đơn vị hệ thống mặc định — trùng appsettings SystemObject:Id của API (cập nhật từ /system/init). */
const DEFAULT_SYSTEM_OBJECT_ID = 100000000;

/** Id đơn vị hệ thống (CMS gửi X-ObjectId = 0 cũng được API hiểu là hệ thống). */
const systemObjectId = (): number => {
    if (typeof window === 'undefined') return DEFAULT_SYSTEM_OBJECT_ID;
    return parseInt(window.localStorage.getItem(SYSTEM_OBJECT_KEY) ?? '') || DEFAULT_SYSTEM_OBJECT_ID;
};

export const setSystemObjectId = (id?: number): void => {
    if (typeof window === 'undefined' || !id) return;
    window.localStorage.setItem(SYSTEM_OBJECT_KEY, id.toString());
};

/** 0 hoặc Id hệ thống = ngữ cảnh hệ thống. */
export const isSystemObject = (id?: number | null): boolean => !id || id === systemObjectId();
